import { userConstants } from "../../constant";

export function sellerBundles(state = { bundles: [] }, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_BUNDLES:
      return { bundles: action.payload };
    default:
      return state;
  }
}
